import { supabase } from './supabase';

export class ApiError extends Error {
  constructor(readonly status: number, readonly code: string, readonly problems: Record<string, string> = {}, readonly reason?: string) {
    super(code);
  }
}

/** Calls the API worker as the signed-in member (Supabase access token in the Authorization header). */
export async function api<T>(path: string, init: { method?: 'GET' | 'POST'; body?: unknown } = {}): Promise<T> {
  const { data } = await supabase.auth.getSession();
  const token = data.session?.access_token;
  const res = await fetch(`/api${path}`, {
    method: init.method ?? 'GET',
    headers: { 'content-type': 'application/json', ...(token ? { authorization: `Bearer ${token}` } : {}) },
    body: init.body === undefined ? undefined : JSON.stringify(init.body),
  });
  const json = (await res.json().catch(() => ({}))) as { error?: string; problems?: Record<string, string>; reason?: string };
  if (!res.ok) throw new ApiError(res.status, json.error ?? 'error', json.problems, json.reason);
  return json as T;
}
